import { useState } from "react";
import useFetch from "../../../../hooks/useFetch";
import { sortByKey } from "../../utils/string";

export default function useLearningStrength() {
  const { request, loading } = useFetch();
  const [data, setData] = useState([]);

  const fetchData = async (url) => {
    const res = await request(url);
    if (res?.data) setData(sortByKey(res.data, "Subject"));
  };

  return { data, loading, fetchData };
}